import React from 'react';
import snipeLogo from '../../assets/snipe_logo.png';
import { useAuth } from '../../context/AuthContext';

function SideNav({ activeTab, setActiveTab, isMobileMenuOpen }) {
    const { user } = useAuth();
    const discordLinked = user?.discordLinked;

    const discordItem = { id: 'discord', label: 'Discord', icon: 'M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z', showWhen: true };
    const oddsItem = { id: 'snipe-feed', label: 'Snipe Feed', icon: 'M4 6h16M4 12h16M4 18h16', showWhen: true };

    const allMenuItems = discordLinked
        ? [
            oddsItem,
            { id: 'results-tracker', label: 'Results Tracker', icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z', showWhen: true },
            { id: 'manage-subscriptions', label: 'Manage Subscriptions', icon: 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z', showWhen: true },
            discordItem,
        ]
        : [
            discordItem,
            { id: 'results-tracker', label: 'Results Tracker', icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z', showWhen: true },
            { id: 'manage-subscriptions', label: 'Manage Subscriptions', icon: 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z', showWhen: true },
            oddsItem,
        ];

    // Filter menu items based on showWhen condition
    const menuItems = allMenuItems.filter(item => item.showWhen);

    const handleNavClick = (itemId) => {
        setActiveTab(itemId);
    };

    return (
        <div 
            className={`fixed left-0 top-0 h-full w-20 bg-gradient-to-b from-[#0f172a] to-[#020617] border-r border-slate-800/50 flex flex-col transform transition-transform duration-300 ease-in-out ${
                isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
            } md:translate-x-0`}
            style={{ zIndex: 9999 }}
        >
            {/* Logo Section */}
            <div className="py-3 px-2 border-b border-slate-800/50 flex items-center justify-center h-[72px]">
                <img 
                    src={snipeLogo} 
                    alt="Snipe Logo" 
                    className="h-12 w-auto object-contain"
                />
            </div>

            {/* Navigation */}
            <nav className="flex-1 px-4 py-6 space-y-2">
                {menuItems.map((item) => (
                    <button
                        key={item.id}
                        type="button"
                        onClick={() => handleNavClick(item.id)}
                        className={`w-full flex items-center justify-center px-4 py-3 rounded-lg transition-all duration-200 ${
                            activeTab === item.id
                                ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white shadow-lg shadow-emerald-500/20'
                                : 'text-slate-400 hover:bg-slate-800/50 hover:text-white'
                        }`}
                        title={item.label}
                    >
                        <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={item.icon} />
                        </svg>
                    </button>
                ))}
            </nav>
        </div>
    );
}

export default SideNav;

